module.exports = __webpack_public_path__ + "static/homepage-hero-background-bb3ea7d28b309a49301e37191aeef84d.png";